<template>
  <div style="width: 100%; height: 100%;z-index=9999999">
    <el-dialog
      title="电站预警"
      :visible.sync="dialogVisible"
      width="85%"
      :center="true"
      :before-close="handleClose"
    >
      <span slot="title" class="title">
        <span>{{title}}</span>
      </span>
      <el-row :gutter="24" class="box-card">
        <el-col :span="7">
          <el-card class="context">
              <div v-html="content"></div>
              <!-- <p>联系方式：</p> -->
          </el-card>
        </el-col>
        <el-col :span="10">
          <div style="margin-top:5%"></div>
          <el-row :span="12">
            <el-col :span="24">
              <video class="context" style="width:100%; height:120%; object-fit: fill" autoplay="autoplay" muted controls>
                <source src="http://120.78.157.194:80/rtsp/0031_video_0001.live.mp4" />
              </video>
            </el-col>
          </el-row>
          <div style="margin-top:5%"></div>
          <el-row :span="12">
            <el-col :span="24">
              <video class="context" style="width:100%; height:120%; object-fit: fill" autoplay="autoplay" muted controls>
                <source src="http://120.78.157.194:80/rtsp/0031_video_0002.live.mp4" />
              </video>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="7">
          <el-card class="box-card">
            <el-table :data="stationInformation" max-height="550" style="width: 100%"
              ><el-table-column prop="realName" header-align="center" align="center" label="姓名"></el-table-column>
              <el-table-column prop="phone" header-align="center" align="center" label="电话"></el-table-column>
              <el-table-column prop="roleType" header-align="center" align="center" label="角色类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.roleType == 1">站长</div>
                  <div v-if="scope.row.roleType == 2">操作员</div>
                </template>
              </el-table-column>
              <el-table-column prop="workStatus" header-align="center" align="center" label="工作状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.workStatus == 1 || scope.row.roleType == 1" style="color:red">当班</div>
                  <div v-else-if="scope.row.workStatus == 2">休班</div>
                </template>
              </el-table-column>
            </el-table> </el-card>
        </el-col>
      </el-row>
      <el-row style="text-align: right;">
        <el-col>
          <el-button type="warning" :disabled="isNaN(Number(data.countDown)) || data.countDown===0" :loading="buttonLoadin" v-on:click="falseAlram">误报(倒计时：<span style="color:red">{{data.countDown}}</span>)</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: ['audioVideoAlarm'],
  watch: {
    audioVideoAlarm: function (newVal, oldVal) {
      console.log('audioVideoAlarm')
      this.dialogVisible = (newVal && true) || false
      this.audioVideoAlarmUrl = newVal.audioVideoAlarmUrl || ''
      this.warningDeviceName = newVal.warningDeviceName || ''
      let si = newVal.stationInformation || []
      for (let i = 0; i < si.length; i++) {
        si[i].username = si[i].realName || si[i].username
        this.powerStation = si[i].name
      }
      this.stationInformation = si
    }
  },
  data() {
    return {
      title:'',
      content:'',
      dialogVisible: false,
      warningDeviceName: '',
      audioVideoAlarmUrl: '',
      powerStation: '',
      stationInformation: [],
      data:null,
      buttonLoadin:false,
    }
  },
  methods: {
    initData(val){
      this.dialogVisible = true
      this.data = val
      this.title = ''
      this.stationInformation = []
      this.content = ''
      this.title = val.templateParam.organName + val.templateParam.sceneLinkName
      //查询电站人员
      axios.get('/api/powermis/powerstationpersonnel/bsGetByStationId/'+val.templateParam.organId).then(response => {
        this.stationInformation = response.data.data
      })
      axios.get('/api/powermis/planmanagement/'+val.planId).then(response => {
        this.content = response.data.data.content
        console.log(response)
        // this.stationInformation = response.data.data
      })
      this.countDownDecrement(val);
    },
    falseAlram(d){
      this.buttonLoadin=true;
      axios.post('/api/powermis/falseAlarm',this.data).then(response => {
        let code = response.data.code;
        if(code == 0){
          this.data.countDown = '已确认误报';
        }
        this.buttonLoadin=false;
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    countDownDecrement(val){
      val['countDownInterval']=setInterval(function(){
        if(isNaN(Number(val.countDown)) || val.countDown == 0){
          clearInterval(val.countDownInterval);
          return
        }
        val.countDown--;
      },"1000");
    }
  }
}
</script>
<style lang="scss" scoped>
.clearfix {
  font-weight: 900;
  font-size: 20px;
}
.title {
  font-size: 26px;
  font-weight: 900;
  color: red;
}
.item {
  font-size: 14px;
  font-weight: 900;
}
.context {
  height: 40rem;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/fireWarning.vue